// For now we have to disable unsafe assignment for all reducers
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { ITestInputState } from "../store/IRcaState";
import { AnyAction } from "@reduxjs/toolkit";
import initialState from "../store/initialState";
import {
  LOAD_TEST_INPUT_SUCCESS,
  UPDATE_TEST_INPUT_FORM_DATA,
  EXECUTE_TEST_START,
  EXECUTE_TEST_THROTTLED,
  EXECUTE_TEST_USER_UNKNOWN,
  CLEAR_SERVER_VALIDATION_ERRORS,
  CLEAR_SPECIFIC_SERVER_VALIDATION_ERROR,
  SET_SERVER_VALIDATION_ERRORS,
  LOAD_TEST_INPUT_START,
  SET_USERNAME_HINT,
  SET_FOCUSED_FIELD_ID,
} from "../actions/actionTypes";

/**
 * The redux reducer for the testInput slice of the state
 *
 * @param state - The test input state
 * @param action - The action being processed
 * @returns The new state
 */
export const testInputReducer = (state: ITestInputState = initialState.testInput, action: AnyAction): ITestInputState => {
  switch (action.type) {
    case LOAD_TEST_INPUT_START:
      return { ...state, currentInputForm: null };

    case LOAD_TEST_INPUT_SUCCESS:
      return { ...state, currentInputForm: action.testInput };

    case UPDATE_TEST_INPUT_FORM_DATA:
      return { ...state, formData: action.formData };

    case SET_SERVER_VALIDATION_ERRORS:
      return { ...state, serverValidationErrors: action.validationErrors };

    case EXECUTE_TEST_START:
      return { ...state, serverValidationErrors: [], executeError: "" };

    case CLEAR_SERVER_VALIDATION_ERRORS:
      return { ...state, serverValidationErrors: [] };

    case CLEAR_SPECIFIC_SERVER_VALIDATION_ERROR:
      return {
        ...state,
        serverValidationErrors: state.serverValidationErrors.filter((e) => e.fieldName !== action.field),
      };

    case EXECUTE_TEST_THROTTLED:
    case EXECUTE_TEST_USER_UNKNOWN:
      return { ...state, executeError: action.error };

    case SET_USERNAME_HINT:
      return { ...state, userNameHint: action.hint };

    case SET_FOCUSED_FIELD_ID:
      return { ...state, focusedFieldId: action.focusedFieldId };

    default:
      return state;
  }
};
